import { xCheckLengths } from "./xCheckLengths.js";
/**
 * Dot product between two arrays.
 * @param A - first array.
 * @param B - second array.
 */
export function xDotProduct(A, B) {
    xCheckLengths(A, B);
    let result = 0;
    for (let i = 0; i < A.length; i++) {
        result += A[i] * B[i];
    }
    return result;
}
//# sourceMappingURL=xDotProduct.js.map